import { render, staticRenderFns } from "./MilestoneRequestPrices.vue?vue&type=template&id=5ed5dc3e&"
import script from "./MilestoneRequestPrices.vue?vue&type=script&lang=js&"
export * from "./MilestoneRequestPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports